
























































































































import { Component, Vue, Watch } from 'vue-property-decorator'
import { getModule } from 'vuex-module-decorators'
import BackofficeCadastroMedicoStore from '@/components/Backoffice/Store/BackofficeCadastroMedicoStore'
import { validateLength, validateEmail, validateCPF } from '@/utils/common'
import { UsuarioTipoEnum } from '@/types/_'
import EventBus from '@/plugins/EventBus'
import _ from 'lodash'

@Component
export default class ComponentBackofficeCadastroMedicoConviteForm extends Vue {
  $refs!: { formConvite: any }

  conviteRules: any = {
    valid: false,
    emailRules: [
      (v: any) => !!v || 'O campo E-mail é obrigatório.',
      (v: any) => validateEmail(v) || 'O E-mail deve ser válido.',
    ],
    nomeRules: [
      (v: any) => !!v || 'O campo Nome é obrigatório.',
      (v: any) => validateLength(v, 8) || 'O campo Nome deve ter pelo menos 8 caracteres.',
    ],
    cpfRules: [
      (v: any) => !!v || 'O campo CPF é obrigatório.',
      (v: any) => validateCPF(v) || 'Cpf inválido.',
    ],
  }

  get getBackofficeCadastroMedicoStore() {
    return getModule(BackofficeCadastroMedicoStore, this.$store)
  }

  loadEnviarConvite: boolean = false
  get loadingEnviarConvite() { return this.loadEnviarConvite }
  set loadingEnviarConvite(value: boolean) { this.loadEnviarConvite = value }

  modalAssociarMedico: boolean = false
  get showModalAssociarMedico() { return this.modalAssociarMedico }
  set showModalAssociarMedico(value: boolean) { this.modalAssociarMedico = value }

  loadAssociarMedicoHospital: boolean = false
  get loadingAssociarMedicoHospital() { return this.loadAssociarMedicoHospital }
  set loadingAssociarMedicoHospital(value: boolean) { this.loadAssociarMedicoHospital = value }

  get getEmailsConvite() { return this.getBackofficeCadastroMedicoStore.emailsConvite }
  set getEmailsConvite(value: any) { this.getBackofficeCadastroMedicoStore.setEmailsConvite(value) }

  removeEmailConvite(index) {
    this.getBackofficeCadastroMedicoStore.removeEmailConvite(index)
  }

  addEmailConvite() {
    this.getBackofficeCadastroMedicoStore.setEmailConvite({ email: '' })
  }

  async sendConvite() {
    this.loadingEnviarConvite = true
    let response = await this.getBackofficeCadastroMedicoStore.getUsuarioTipoExistsByCpf(this.getBackofficeCadastroMedicoStore.convite.cpf)
    if (response.success && response.data.tipo !== UsuarioTipoEnum.Remuneracao) {
      switch (this.getBackofficeCadastroMedicoStore.usuarioTipo.tipo) {
        case UsuarioTipoEnum.Medico:
          this.showModalAssociarMedico = true
          break

        default:
          EventBus.$emit('setSnackbar', { show: true, text: 'O cpf informado consta cadastrado como secretária.', icon: 'warning', color: '#C62828' })
          break
      }
    } else {
      response = await this.getBackofficeCadastroMedicoStore.sendConvite()
      if (response.success) {
        EventBus.$emit('setSnackbar', { show: true, text: 'Convite enviado com sucesso!', icon: 'done', color: '#2E7D32' })
      } else {
        EventBus.$emit('setSnackbar', { show: true, text: response.data.mensagem || 'Ocorreu um erro ao enviar o convite.', icon: 'warning', color: '#C62828' })
      }

      this.$refs.formConvite.reset()
      this.getEmailsConvite = []
    }

    this.loadingEnviarConvite = false
  }

  async associarMedicoHospital() {
    this.loadingAssociarMedicoHospital = true
    const response = await this.getBackofficeCadastroMedicoStore.associarMedicoHospital()
    if (response.success) {
      EventBus.$emit('setSnackbar', { show: true, text: 'Medico associado com sucesso!', icon: 'done', color: '#2E7D32' })
      this.$refs.formConvite.reset()
    } else {
      EventBus.$emit('setSnackbar', { show: true, text: response.message || 'Ocorreu um erro na associação do médico.', icon: 'warning', color: '#C62828' })
    }

    this.showModalAssociarMedico = false
    this.loadingAssociarMedicoHospital = false
  }

  @Watch('showModalAssociarMedico')
  onChangeShowModalAssociarMedico(value: boolean) {
    //
  }

  mounted() {
    EventBus.$on('formConviteReset', (value: boolean) => {
      if (value) this.$refs.formConvite.reset()
    })
  }
}
